import { LocalSettingsType } from 'data/Auth/types'

import { ActionType } from '../../types'
import * as AT from './actionTypes'

const INITIAL_STATE = { orderFilledSound: true }

const localSettingsReducer = (state: LocalSettingsType = INITIAL_STATE, action: ActionType) => {
  if (!action.type) return state

  switch (action.type) {
    case AT.SET_SETTINGS:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}

export default localSettingsReducer
